module.exports = __webpack_public_path__ + "static/img/center1.33809af7.png";